import React, { useEffect, useRef, useState } from "react";
import { AddCircleOutline, Delete, Edit } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import MasterViewController from "../../redux/actions/masterApiActions";
import RoleFormModal from "./AddRoles";
import ExportButton from "../../components/ag grid/ExportButton";
import ReusableGrid from "../../components/ag grid/ReusableGrid";

import "../../styles/styles.css";
import "../../styles/layout.css";

const RoleListPage = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [editRole, setEditRole] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);

  const { getRoles, deleteRole } = MasterViewController();
  const { roles } = useSelector((state) => state.master);

  useEffect(() => {
    dispatch(getRoles());
  }, [dispatch]);

  const handleDelete = (id) => dispatch(deleteRole(id));

  const handleEdit = (role) => {
    setEditRole(role);
    setShowModal(true);
  };

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left",
    },
    {
      headerName: "SR.No",
      valueGetter: (params) => params.node.rowIndex + 1,
      maxWidth: 80,
    },
    {
      headerName: "Role Name",
      field: "role_name",
      flex: 1,
    },
    {
      headerName: "Actions",
      field: "actions",
      pinned: "right",
      minWidth: 120,
      maxWidth: 150,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          <Tooltip title="Edit">
            <IconButton size="small" onClick={() => handleEdit(params.data)}>
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              size="small"
              sx={{ color: "#d32f2f" }}
              onClick={() => handleDelete(params.data.id)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="d-flex  mb-3" style={{ justifyContent: "space-between" }}>
        <div>
          {selectedRows.length > 0 && (
            <ExportButton
              gridRef={gridRef}
              fileName="roles.xlsx"
              exportColumns={["role_name"]}
            />
          )}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <PageSizeSelector
          pageSize={pageSize}
          onChange={(e) => setPageSize(Number(e.target.value))}
        />
        <div className="mt-2">
        <Button
          variant="contained"
          startIcon={<AddCircleOutline />}
          onClick={() => {
            setEditRole(null);
            setShowModal(true);
          }}
          sx={{
              borderRadius: "8px",
              backgroundColor: "#1976d2",
              textTransform: "none",
              paddingX: 2,
              height: "40px",             
              fontSize: "0.875rem",                  
            }}
        >
          Add Role
        </Button>
        </div>
        </div>
      </div>

      <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Role List</h3>
          </Col>
        </Row>
      </div>

      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={roles}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>

      <RoleFormModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        initialData={editRole}
      />
    </div>
  );
};

export default RoleListPage;
